import React from 'react';
import { HelmetProvider } from 'react-helmet-async';

export default class MetadataProvider extends React.Component {
	render() {
		return <HelmetProvider>{this.props.children}</HelmetProvider>;
	}
}
